<template>
	<div class="tabs-common">
		<article class="context" v-html="compiledMarkdown"></article>
	</div>
</template>

<script>
	import marked from 'marked'

	export default {
		props: {
			detail: {
				type: String,
				default: ""
			}
		},
		computed: {
			compiledMarkdown () {
				return marked(this.detail, { sanitize: true })
			}
		}
	}
</script>

<style lang="scss">
	.tabs-common {
		.context {
			font-size: 12px;
		}
		width: 100%;
		height: auto;
		h2 {
			margin-top: 11px;
			width: 46px;
			height: 24px;
			background: #e8e9ec;
			border-radius: 4px;
			font-size: 14px;
			font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
			font-weight: 300;
			text-align: center;
			color: #242424;
			line-height: 24px;
			margin-bottom: 8px;
		}
		div {
			margin-top: 7px;
			ul {
				li {
					span {
						font-size: 14px;
						font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
						font-weight: 300;
						text-align: left;
						color: #8e8e8e;
						line-height: 20px;
					}
				}
			}
		}
	}
</style>